import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import CustomSelect from "../../../../../Components/common/CustomSelect/CustomSelect";
import CustomMultiSelect from "../../../../../Components/common/CustomMultiSelect/CustomMultiSelect";
import HeaderStatusToggle from "../../Components/HeaderStatusToggle";
import Backdrop from "../../../../../Components/UI/Backdrop/Backdrop";

import { DAY_OPTIONS, TIME_OPTIONS, DURATION_OPTIONS } from "./constants";

import {
  RequestGetUpdateSchedulerConfigs,
  RequestSetUpdateSchedulerConfigs,
} from "../../../../../store/actions/settingsActions";

import "./styles.scss";

const UpdateScheduler = () => {
  const dispatch = useDispatch();

  const [days, setDays] = useState(DAY_OPTIONS);
  const [startTime, setStartTime] = useState(TIME_OPTIONS[0]);
  const [duration, setDuration] = useState(DURATION_OPTIONS[0]);
  const [active, setActive] = useState(false);

  const configsFromDB = useSelector((state) => state.settings.updateSchedulerConfigs);
  const getConfigsLoading = useSelector((state) => state.settings.updateSchedulerConfigsLoading);
  const setConfigsLoading = useSelector((state) => state.settings.setUpdateSchedulerConfigsLoading);

  useEffect(() => {
    dispatch(RequestGetUpdateSchedulerConfigs());
  }, [dispatch]);

  useEffect(() => {
    if (Object.keys(configsFromDB).length > 0) {
      const { days, start_time, duration, active } = configsFromDB;
      setDays(
        DAY_OPTIONS.map((day) => (days.includes(day.value) ? { ...day, selected: true } : day)),
      );
      setStartTime(TIME_OPTIONS.filter((time) => time.id === start_time)[0]);
      setDuration(DURATION_OPTIONS.filter((dur) => dur.id === duration)[0] || DURATION_OPTIONS[0]);
      setActive(active);
    }
  }, [configsFromDB]);

  const toggleActiveStateHandler = () => {
    if (getConfigsLoading || setConfigsLoading) return;
    dispatch(RequestSetUpdateSchedulerConfigs({ active: !active }));
  };

  const checkSaveButtonDisabled = () => {
    if (Object.keys(configsFromDB).length === 0) return true;

    const selectedDayList = days
      .filter((day) => day.selected)
      .map((filteredDay) => filteredDay.value);

    if (selectedDayList.length === 0) return true;
    else if (configsFromDB.start_time !== startTime.id) return false;
    else if (configsFromDB.duration !== duration.id) return false;
    else if (
      configsFromDB.days.length !== selectedDayList.length ||
      !configsFromDB.days.every((sd) => selectedDayList.includes(sd)) ||
      !selectedDayList.every((sd) => configsFromDB.days.includes(sd))
    )
      return false;

    return true;
  };

  const saveHandler = () => {
    if (getConfigsLoading || setConfigsLoading) return;

    const selectedDayList = days
      .filter((day) => day.selected)
      .map((filteredDay) => filteredDay.value);

    const selectedStartTime = startTime.id;
    const selectedDuration = duration.id;

    dispatch(
      RequestSetUpdateSchedulerConfigs({
        days: selectedDayList,
        start_time: selectedStartTime,
        duration: selectedDuration,
      }),
    );
  };

  return (
    <div className="update-scheduler">
      <div className="update-scheduler__header">
        <h1>Update Scheduler</h1>
      </div>
      <div className="update-scheduler__body">
        <div className="update-scheduler__body__header">
          <h3>Update Scheduler</h3>
          <HeaderStatusToggle active={active} onClick={toggleActiveStateHandler} />
          <p>NOTE: The system will be updated every week at the time configured below.</p>
        </div>
        <div className="update-scheduler__body__content">
          {active ? (
            <p className="update-scheduler__body__message">
              Auto update will be ON for{" "}
              {DURATION_OPTIONS.filter((d) => d.id === configsFromDB.duration)[0]?.value} at{" "}
              {configsFromDB?.start_time} on{" "}
              {configsFromDB?.days?.map((d) => d.charAt(0).toUpperCase() + d.slice(1)).join(", ")}
            </p>
          ) : null}
          <div className="update-scheduler__body__groups">
            <div className="update-scheduler__body__group">
              <p className="update-scheduler__body__label">Day</p>
              <CustomMultiSelect options={days} setOptions={setDays} placeholder="Select day..." />
            </div>
            <div className="update-scheduler__body__group">
              <p className="update-scheduler__body__label">Start Time</p>
              <CustomSelect
                width="86px"
                data={TIME_OPTIONS}
                select={startTime}
                setSelected={setStartTime}
                height="40px"
              />
            </div>
            <div className="update-scheduler__body__group">
              <p className="update-scheduler__body__label">Duration</p>
              <CustomSelect
                width="106px"
                data={DURATION_OPTIONS}
                select={duration}
                setSelected={setDuration}
                height="40px"
              />
            </div>
          </div>
          <button
            className="primary-button"
            onClick={saveHandler}
            disabled={checkSaveButtonDisabled()}>
            Save
          </button>

          <Backdrop
            spinner={false}
            absolute
            show={!active}
            message="Update scheduler is inactive! Turn on the Status toggle above to activate it."
            messageStyle={{ paddingTop: 0 }}
          />
        </div>
      </div>
    </div>
  );
};

export default UpdateScheduler;
